"use strict";
/****************************************************
 * Audit Information Platform Component
 * 基础组件库
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTranslate = exports.getLocale = exports.MenuButton = exports.CrossRotate = exports.FieldsFilter = exports.RadioRef = exports.CheckRef = exports.TreeRef = exports.TableRef = exports.SelectRef = exports.TextRef = exports.NumberRef = exports.Message = exports.NoRefSearch = exports.AIPTable = exports.ErrorPage = exports.Toolbar = exports.AIPSearchPanel = exports.RefItem = exports.Codec = exports.isMac = exports.evil = exports.isNumberStr = exports.isNumber = exports.Utils = exports.Request = exports.request = exports.version = void 0;
// -----AIP Components-----
var RefItem_1 = require("./components/RefItem");
exports.RefItem = RefItem_1.default;
var AIPSearchPanel_1 = require("./components/AIPSearchPanel");
exports.AIPSearchPanel = AIPSearchPanel_1.default;
var utils_1 = require("./utils");
Object.defineProperty(exports, "request", { enumerable: true, get: function () { return utils_1.request; } });
Object.defineProperty(exports, "Request", { enumerable: true, get: function () { return utils_1.request; } });
Object.defineProperty(exports, "Utils", { enumerable: true, get: function () { return utils_1.Utils; } });
Object.defineProperty(exports, "isNumber", { enumerable: true, get: function () { return utils_1.isNumber; } });
Object.defineProperty(exports, "isNumberStr", { enumerable: true, get: function () { return utils_1.isNumberStr; } });
Object.defineProperty(exports, "evil", { enumerable: true, get: function () { return utils_1.evil; } });
Object.defineProperty(exports, "isMac", { enumerable: true, get: function () { return utils_1.isMac; } });
Object.defineProperty(exports, "getTranslate", { enumerable: true, get: function () { return utils_1.getTranslate; } });
Object.defineProperty(exports, "getLocale", { enumerable: true, get: function () { return utils_1.getLocale; } });
var NoRefSearch_1 = require("./components/NoRefSearch");
exports.NoRefSearch = NoRefSearch_1.default;
var Message_1 = require("./components/Message");
exports.Message = Message_1.default;
var NumberRef_1 = require("./components/NumberRef");
exports.NumberRef = NumberRef_1.default;
var TextRef_1 = require("./components/TextRef");
exports.TextRef = TextRef_1.default;
var SelectRef_1 = require("./components/SelectRef");
exports.SelectRef = SelectRef_1.default;
var TableRef_1 = require("./components/TableRef");
exports.TableRef = TableRef_1.default;
var TreeRef_1 = require("./components/TreeRef");
exports.TreeRef = TreeRef_1.default;
var CheckRef_1 = require("./components/CheckRef");
exports.CheckRef = CheckRef_1.default;
var RadioRef_1 = require("./components/RadioRef");
exports.RadioRef = RadioRef_1.default;
var Toolbar_1 = require("./Toolbar");
exports.Toolbar = Toolbar_1.default;
var ErrorPage_1 = require("./ErrorPage");
exports.ErrorPage = ErrorPage_1.default;
var AIPTable_1 = require("./AIPTable");
exports.AIPTable = AIPTable_1.default;
var FieldsFilter_1 = require("./components/FieldsFilter");
exports.FieldsFilter = FieldsFilter_1.default;
var CrossRotate_1 = require("./components/CrossRotate");
exports.CrossRotate = CrossRotate_1.default;
var MenuButton_1 = require("./components/MenuButton");
exports.MenuButton = MenuButton_1.default;
var Codec_1 = require("./components/Codec");
exports.Codec = Codec_1.default;
exports.version = "Audit Information Platform 1.0.01";
window.aipVersion = exports.version;
